

export default class ExceedLimitsError extends Error {
  constructor(message) {
    super(message)
    this.name = 'ExceedLimitsError'
  }
}
